import { Suspense } from 'react';
import { Outlet, Navigate, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import classes from './styles.module.css';
import { authSelector } from 'src/store/reducers/auth';
import { isRTL } from 'src/utils/global';
import { useLocaitonQuery } from 'src/hooks';
import { LangMenu, LoadingPage, Logo } from 'src/components';
import AnimatedBG from 'src/components/animatedBg/AnimatedBG';


const AuthLayout = () => {
    const auth = useSelector(authSelector);
    const { query } = useLocaitonQuery();
    const next = query.get('next');
    const redirectPath = next && !next.includes('auth') ? next : '/';


    return auth.access ? <Navigate to={redirectPath} replace={true} /> : (
        <main className={`${classes.auth__layout} ${isRTL() && "rtl"} ${isRTL() && classes.rtl}`} >
            <div className={classes.content} >
                <div className={classes.content__topbar}>
                    <Link to="/">
                        <Logo className={classes.content__logo} />
                    </Link>
                    <LangMenu className={classes.content__lang} />
                </div>
                <div className={classes.content__body}>
                    <Suspense fallback={<LoadingPage />}>
                        <Outlet />
                    </Suspense>
                </div>
            </div>
            <div className={classes.bg}>
                <AnimatedBG className={classes.auth__animation} />
            </div>

        </main >

    );
}
export default AuthLayout;
